import { render, staticRenderFns } from "./SurveyAnswerPage.vue?vue&type=template&id=1f090893&scoped=true"
import script from "./SurveyAnswerPage.vue?vue&type=script&lang=js"
export * from "./SurveyAnswerPage.vue?vue&type=script&lang=js"
import style0 from "./SurveyAnswerPage.vue?vue&type=style&index=0&id=1f090893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f090893",
  null
  
)

export default component.exports